"use client";

import { useState } from "react";

import { useConfig } from "@stadium/hooks/lib/use-config";

import { NewCountrySelector } from "@stadium/ui/src/components/country-selector";
import CountryFlag from "@stadium/ui/src/shared/country-flag";

import useAllCountries from "@hooks/countries/use-all-countries";
import { useStoreContext } from "@components/store/provider";

import LinkWithLang from "@sharedComponents/link-with-lang";

import { getDefaultShopNumber } from "@selectors/config";
import { getIsLockerShop } from "@selectors/store";

import { DEFAULT_COUNTRY } from "@stadium/helpers/country/constants";
import { STORE_HOME_PAGE_PATHNAME } from "@constants/routes";
import { OLD_STORE_HOME_PAGE_PATHNAME } from "@constants/old-routes";
import { DEFAULT_GIFT_SHOP_CODE } from "@stadium/constants/shop";

import styles from "./main.module.scss";

const CatalogCountrySelection = ({ store = {}, buttonText }) => {
  const defaultShopNumber = useConfig(getDefaultShopNumber);
  const isLockerShop = getIsLockerShop({ store });
  const { isNewRoute, lang } = useStoreContext();

  const { allCountriesList } = useAllCountries({ includeGlobalCountry: true });
  const [selectedCountry, setSelectedCountry] = useState(allCountriesList[0] || DEFAULT_COUNTRY);

  const swagCatalogQuery = {
    countryCode: selectedCountry.iso?.toLowerCase(),
    storeNumber: store?.number,
    slug: store?.code,
  };

  const giftCatalogQuery = {
    countryCode: selectedCountry.iso?.toLowerCase(),
    lang,
    storeNumber: defaultShopNumber,
    slug: DEFAULT_GIFT_SHOP_CODE,
  };

  const renderLinks = () => (
    <>
      <LinkWithLang
        pathname={isNewRoute ? STORE_HOME_PAGE_PATHNAME : OLD_STORE_HOME_PAGE_PATHNAME}
        query={swagCatalogQuery}
        className={styles.catalogButton}
        styleType="link"
      >
        {buttonText || "View Swag Catalog"}
      </LinkWithLang>
      {isLockerShop && (
        <LinkWithLang
          pathname={isNewRoute ? STORE_HOME_PAGE_PATHNAME : OLD_STORE_HOME_PAGE_PATHNAME}
          query={giftCatalogQuery}
          className={styles.catalogButton}
          styleType="link"
        >
          View gift Catalog
        </LinkWithLang>
      )}
    </>
  );

  return (
    <>
      <div className={styles.dropdownBlock}>
        <NewCountrySelector
          currencies={[]}
          countries={allCountriesList}
          onSelectCountry={setSelectedCountry}
          selectedCountry={selectedCountry}
          flagWidth={32}
          flagHeight={24}
          type="round"
          showCountryChangeModal={false}
          availableLanguages={[]}
          showLanguages={false}
          parentLabel="Select a country"
          dropdownLabel={
            <div className={styles.countryContainer}>
              <CountryFlag country={selectedCountry} flagWidth={32} flagHeight={24} type="round" />
              <div className={styles.countryName}>{selectedCountry?.name}</div>
              <div className={styles.iconChevronDown} />
            </div>
          }
        />
      </div>

      {renderLinks()}
    </>
  );
};

export default CatalogCountrySelection;
